$.fn.Masonry = function (options = {}) {
  let self = this;
  let items = self.find(".grid__item:not(.ajax-load-more__end-page)");
  self.css('display', 'flex');

  self.getColumnCount = function() {
    let width = $(window).width();
    let columnCount = null;

    for (let breakpoint in options) {
      if (width <= parseInt(breakpoint, 10)) {
        columnCount = options[breakpoint];
        break;
      }
    }

    if (columnCount === null) {
      let match = self.attr("class").match(/grid--col-(\d+)/);
      columnCount = match ? parseInt(match[1], 10) : 3;
    }

    return columnCount;
  }

  self.buildMasonry = function() {
    let columnCount = self.getColumnCount();
    let columns = [];

    self.find('.grid__item:not(.ajax), .masonry-column').remove();

    for (let i = 0; i < columnCount; i++) {
      columns.push($("<div class='masonry-column'></div>"));
    }

    items.each(function (index) {
      let columnIndex = index % columnCount;
      columns[columnIndex].append($(this));
    });

    self.append(columns);
    self.find('.grid__loader').appendTo(self);
  }

  self.addElements = function() {
    if (self.find('> .grid__item:not(.ajax-load-more__end-page)').length) {
      items = items.pushStack(items.toArray().concat(self.find('> .grid__item:not(.ajax-load-more__end-page)').toArray()));
      self.buildMasonry();
    }
  }

  self.data('addElements', self.addElements);

  self.buildMasonry();

  let resizeTimeout;
  $(window).on("resize", function () {
    self.closest('.ajax-load-more__wrapper').css('max-height', '')
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(self.buildMasonry, 200);
  });

  return self;
};
